/* React hooks */
import {useEffect, useState} from "react";
/* Contexts */
import useAuth from "../hooks/useAuth";
import useDeceased from "../hooks/useDeceased";
/* API Contexts */
import {getDeceasedAdministrator, getDeceasedInfos, getDeceasedList} from "../api/pro/deceasedReq";
import {getAgencyHeader} from "../api/pro/agencyReq";
/* Helpers */
import {deceasedOrderDashboard} from "../helper/orders";
/* Components */
import Dashboard from "../components/common/dashboard/Dashboard";
import DeceasedDetails from "../components/common/DeceasedDetails";
import Header from "../components/common/Header";
import Icon from "../components/common/Icon";
import {safeJwtDecode} from "../helper/jwtHelper";
import {Link, useNavigate} from "react-router-dom";
import usePager from "../hooks/usePager";
import {getLomacoImport} from "../api/admin/lomacoReq";
/* Images */
import listeDefuntsIcon from "../img/v2_i_listeDefunts.png";


export default function Home() {
    const { auth } = useAuth();
    const token = auth.token;
    const { deceased, setDeceased,
        deceasedList, setDeceasedList,
        setDeceasedInfos,
        setLomacoData
    } = useDeceased();
    const { currentPage, itemsPerPage, totalPages, setTotalPages } = usePager();
    const [ totalItems, setTotalItems ] = useState();
    const [ deceasedAdmin, setDeceasedAdmin ] = useState();
    const [ agencyInfo, setAgencyInfo ] = useState(null);
    const decodedToken = safeJwtDecode(token);
    const id = decodedToken?.agency;
    const deceasedId = deceased?.id;
    const navigate = useNavigate();
    const [ hasLomacoId, setHasLomacoId ] = useState(false);

    const deceasedListApi = async () => {
        const response = await getDeceasedList(token,id, currentPage, itemsPerPage)
        setDeceasedList(response?.deceasedList)
        setTotalItems(response?.totalItems)
        setHasLomacoId(response?.agencyLomaco)
    };

    const deceasedInfosApi = async () => {
        const response = await getDeceasedInfos(token, deceasedId)
        setDeceasedInfos(response)
    };

    useEffect(() => {
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ totalItems, itemsPerPage ]);

    const deceasedAdminApi = async () => {
        const response = await getDeceasedAdministrator(token, deceasedId)
        setDeceasedAdmin(response)
    };

    const handleLomacoImport = async () => {
        const response = await getLomacoImport(id, token)
        setLomacoData(response?.lomaco)
        navigate("/import-lomaco")
    }

    const agencyInfoApi = async () => {
        const response = await getAgencyHeader(token, id)
        setAgencyInfo(response)
    };

    useEffect(() => {
        agencyInfoApi()
    }, [id]);

    useEffect(() => {
        setDeceasedInfos("")
        setDeceasedAdmin("")
        setDeceased("")
    }, []);

    useEffect(() => {
        if (deceasedId) {
            deceasedInfosApi()
            deceasedAdminApi()
        }
    }, [ deceasedId ]);


    useEffect(() => {
        if(deceasedList?.length < 1) {
            deceasedListApi()
        }
    }, [ deceasedList ]);

    useEffect(() => {
        deceasedListApi()
    }, [ itemsPerPage, currentPage, totalPages ]);

    return (
        <main>
            <Header location="Tableau de bord" parent="" agencyInfo={agencyInfo} />
            <div className="content-container home-page">
                <div className="home-page-header-row">
                    <Icon source={listeDefuntsIcon} span="Liste des défunts"/>
                    <div className="flex-buttons">
                        {hasLomacoId && <button className="add-button" onClick={handleLomacoImport}><i className="fa fa-download"/><span>Import Lomaco</span></button>}
                        <button><Link to="defunt/nouveau"><i className="fa fa-plus"></i><span>Nouveau défunt</span></Link></button>
                    </div>
                </div>
                <div className="dashboard home-dashboard">
                    {deceasedList &&
                        <Dashboard totalItems={totalItems} deceasedListApi={deceasedListApi} location="Tableau de bord" dataObject={deceasedList || []}
                                   order={deceasedOrderDashboard}/>
                    }
                </div>
                <DeceasedDetails deceasedListApi={deceasedListApi} id={deceasedId} location="Tableau de bord" admin={deceasedAdmin || []}/>
            </div>
        </main>
    )
}